import React, { memo } from 'react';
import { ESkillDetailTab } from '../../../types/skillDetail';
import './index.scss';

/**
 * Skill 详情页 Tab 内容项定义
 */
export interface ISkillDetailTabItem {
  /** Tab 唯一标识 */
  id: ESkillDetailTab;
  /** Tab 对应的渲染内容 */
  component: React.ReactNode;
}

/**
 * Skill 详情页 Tab 内容区 Props（Tab 栏已合并至 SkillDetailHeader）
 */
export interface ISkillDetailTabsProps {
  /** 当前激活 Tab */
  activeTab: ESkillDetailTab;
  /** Tab 内容项列表 */
  tabs: ISkillDetailTabItem[];
}

/**
 * Skill 详情页 Tab 内容区（Tab 栏已合并至 SkillDetailHeader）
 */
const SkillDetailTabs: React.FC<ISkillDetailTabsProps> = ({
  activeTab,
  tabs,
}) => (
  <div className="dba-skill-detail-tabs">
    <div className="dba-skill-detail-tabs__panel" role="tabpanel">
      {tabs.map((item) =>
        (item.id === activeTab ? (
          <React.Fragment key={item.id}>{item.component}</React.Fragment>
        ) : null),
      )}
    </div>
  </div>
);

export default memo(SkillDetailTabs);
